import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { isOnlinePos, useGetPointsOfSalesQuery } from '~entities/pos';

import { MultiSelectFilter } from '~shared/ui/multi-select-filter';

import {
  getBusinessOptions,
  getStoreOptions,
} from '../../lib/get-orders-filter-options';
import { ORDER_STATUS_OPTIONS } from '../../lib/order-status';
import type { OrdersFiltersValue } from '../../model/orders-filters';

type FieldProps = {
  onChange?: () => void;
};

function useOnlinePosList() {
  const { data } = useGetPointsOfSalesQuery();

  return useMemo(() => data?.filter(isOnlinePos) ?? [], [data]);
}

export function BusinessSelect({ onChange }: FieldProps) {
  const { setValue } = useFormContext<OrdersFiltersValue>();
  const onlinePosList = useOnlinePosList();
  const options = useMemo(
    () => getBusinessOptions(onlinePosList),
    [onlinePosList]
  );

  return (
    <MultiSelectFilter
      name="merchantIds"
      label="Businesses"
      options={options}
      onValueChange={() => {
        setValue('posIds', [], { shouldDirty: true });
        onChange?.();
      }}
    />
  );
}

export function StoreSelect({ onChange }: FieldProps) {
  const onlinePosList = useOnlinePosList();
  const selectedMerchantIds = useWatch<OrdersFiltersValue, 'merchantIds'>({
    name: 'merchantIds',
  });
  const options = useMemo(
    () => getStoreOptions(onlinePosList, selectedMerchantIds ?? []),
    [onlinePosList, selectedMerchantIds]
  );

  return (
    <MultiSelectFilter
      name="posIds"
      label="Stores"
      options={options}
      onValueChange={onChange}
    />
  );
}

export function StatusSelect({ onChange }: FieldProps) {
  return (
    <MultiSelectFilter
      name="statuses"
      label="Status"
      options={ORDER_STATUS_OPTIONS}
      onValueChange={onChange}
    />
  );
}
